import '../global.scss';
import PnrLookup from '../pages/PnrLookup.svelte';

const pnrLookup = new PnrLookup({
    target: document.body,
    props: window.componentProps
});

export default pnrLookup;
